import { render, staticRenderFns } from "./LayoutHeaderUser.vue?vue&type=template&id=5c89a100&scoped=true&"
import script from "./LayoutHeaderUser.vue?vue&type=script&lang=js&"
export * from "./LayoutHeaderUser.vue?vue&type=script&lang=js&"
import style0 from "./LayoutHeaderUser.vue?vue&type=style&index=0&id=5c89a100&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c89a100",
  null
  
)

export default component.exports